import { AuthRoute } from "components/Route/AuthRoute";
import { Routes } from "react-router-dom";
import { AboutYourself } from "../AboutYou/AboutYourself";
import { AdditionalDebts } from "../AdditionalDebts/AdditionalDebts";
import { PendingAcceptance } from "../ApplicationResults/PendingAcceptance";
import { Expenses } from "../Expenses/Expenses";
import { ImportantInformation } from "../ImportantInformation/ImportantInformation";
import { Income } from "../Income/Income";
import { IncreaseCreditLimit } from "../IncreaseCreditLimit/IncreaseCreditLimit";
import { ReviewDetails } from "../ReviewDetails/ReviewDetails";

export const IncreaseCreditLimitPages = () => (
  <Routes>
    <AuthRoute path="/" component={IncreaseCreditLimit} />
    <AuthRoute path="/important-information" component={ImportantInformation} />
    <AuthRoute path="/about-yourself" component={AboutYourself} />
    <AuthRoute path="/employment-income" component={Income} />
    <AuthRoute path="/expenses" component={Expenses} />
    <AuthRoute path="/additional-debts" component={AdditionalDebts} />
    <AuthRoute path="/review-submit" component={ReviewDetails} />
    <AuthRoute path="/pending-acceptance" component={PendingAcceptance} />
  </Routes>
);
